import React, { useState, useEffect } from 'react';
import { Modal, Select } from 'antd';
import Box from '~/components/Box';
import PageTitle from '~/components/PageTitle';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import ProfitAndLossReportDirect from '../Reports/ProfitAndLossReportDirect';
import EstimatedActualReport from '../Reports/EstimatedActualReport';
import ProfitAndLossDetailReportDirect from '../Reports/ProfitAndLossDetailReportDirect';
import CashFlowReportDirect from '../Reports/CashFlowReportDirect';

const { Option } = Select;

export default function ReportModal({ visible, onClose, record: { companyName: name, qbId }, reportType }) {

  const { t } = useTranslation();
  // const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(reportType);

  const handleReportChange = value => {
    setSelectedReport(value);
  };

  useEffect(() => {
    if (reportType) {
      setSelectedReport(reportType);
    }
  }, [reportType]);

  return (
    <Modal
      title={`${name} Reports`}
      width={1200}
      onCancel={onClose}
      open={visible}
      // loading={loading}
      // footer={<ModalFooter loading={loading} onCancel={onClose} cancelColor="default" />}
      footer={<ModalFooter onCancel={onClose} cancelColor="default" />}
    >
      {/* <Spin spinning={loading}> */}
        <Box>
          <PageTitle title="Reports" />
          <div style={{ marginBottom: 16 }}>
            <Select value={selectedReport} style={{ width: 600 }} onChange={handleReportChange}>
              <Option value="CashFlow">{t('screens:reports.cashFlow')}</Option>
              <Option value="ProfitAndLoss">{t('screens:reports.profitAndLoss')}s</Option>
              <Option value="ProfitAndLossDetail">{t('screens:reports.profitAndLossDetail')}</Option>
              <Option value="EstimatedActual">{t('screens:reports.estimatedActual')}</Option>
              {/* Future reports can be added here */}
            </Select>
          </div>
          {selectedReport === 'CashFlow' && <CashFlowReportDirect name={name} qbId={qbId} />}
          {selectedReport === 'ProfitAndLoss' && <ProfitAndLossReportDirect name={name} qbId={qbId} />}
          {selectedReport === 'ProfitAndLossDetail' && <ProfitAndLossDetailReportDirect name={name} qbId={qbId} />}
          {selectedReport === 'EstimatedActual' && <EstimatedActualReport />}
        </Box>
      {/* </Spin> */}
    </Modal>
  );
}
